import {PropertyType} from "./property-type.enum";

export class Property {

  name: string;

  value: any;

  type: PropertyType;

  constructor(attr: { name: string, value: any, type: PropertyType}) {
    this.name = attr.name;
    this.value = attr.value;
    this.type = attr.type;
  }
}
